/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_aO_97_79 as Componente_aO_97_79,
  rec_EstadoError as EstadoError,
  rec_JSXRuntime as JSXRuntime,
  rec_Paginacion as Paginacion,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_api as api,
} from "../../runtime/index.jsx";
export function AuditoriaProyecto(e) {
  let t = (0, ReactCompiler.c)(19),
    { proyecto: n } = e,
    [r, i] = (0, React.useState)(0),
    a;
  t[0] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((a = {
        items: [],
        total: 0,
      }),
      (t[0] = a))
    : (a = t[0]);
  let [o, s] = (0, React.useState)(a),
    [c, l] = (0, React.useState)(``),
    [u, f] = (0, React.useState)(!0),
    p,
    m;
  (t[1] !== r || t[2] !== n.id
    ? ((p = () => {
        let e = !0;
        return (
          f(!0),
          api(`/auditoria?proyecto=${n.id}&pagina=${r}&tamano=25`)
            .then((t) => {
              e && (s(t), l(``));
            })
            .catch((t) => {
              e && l(t.message);
            })
            .finally(() => {
              e && f(!1);
            }),
          () => {
            e = !1;
          }
        );
      }),
      (m = [n.id, r]),
      (t[1] = r),
      (t[2] = n.id),
      (t[3] = p),
      (t[4] = m))
    : ((p = t[3]), (m = t[4])),
    (0, React.useEffect)(p, m));
  let h;
  t[5] === c
    ? (h = t[6])
    : ((h = <EstadoError mensaje={c} />), (t[5] = c), (t[6] = h));
  let _;
  t[7] !== u || t[8] !== o.items
    ? ((_ = u ? (
        <p children={`Cargando historial…`} />
      ) : o.items.length === 0 ? (
        <p children={`No hay registros de auditoría.`} />
      ) : (
        <ul
          className={`divide-y divide-(--border)`}
          children={o.items.map(Componente_aO_97_79)}
        />
      )),
      (t[7] = u),
      (t[8] = o.items),
      (t[9] = _))
    : (_ = t[9]);
  let v;
  t[10] !== u || t[11] !== o.total || t[12] !== r
    ? ((v = (
        <Paginacion
          pagina={r}
          tamano={25}
          total={o.total}
          onChange={i}
          cargando={u}
        />
      )),
      (t[10] = u),
      (t[11] = o.total),
      (t[12] = r),
      (t[13] = v))
    : (v = t[13]);
  let y;
  return (
    t[14] !== u || t[15] !== h || t[16] !== _ || t[17] !== v
      ? ((y = (
          <div
            className={`flex flex-col gap-3`}
            aria-busy={u}
            children={[h, _, v]}
          />
        )),
        (t[14] = u),
        (t[15] = h),
        (t[16] = _),
        (t[17] = v),
        (t[18] = y))
      : (y = t[18]),
    y
  );
}
